import React, { useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Modal as MuiModal } from '@mui/material';
import { Link } from 'components/UI/Link/Link';
import { CloseButton } from 'components/UI/CloseButton/CloseButton';
import { ReactComponent as ShareIcon } from 'assets/icons/svgs/icon-share2.svg';
import './DeliveryMethodsFaqModal.scss';

export const DeliveryMethodsFaqModal = (props) => {
  const { faqs, modalTitle, readMoreText, showMoreText } = props;
  const [open, setOpen] = useState(false);
  const openModalHandler = (event) => {
    setOpen(true);
    event.preventDefault();
  };
  const closeModalHandler = () => setOpen(false);

  return (
    <>
      {' '}
      <a href="#" onClick={openModalHandler} className="link-external">
        {readMoreText}
      </a>
      <MuiModal
        open={open}
        onClose={closeModalHandler}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableScrollLock
        sx={{
          overflowX: 'hidden',
          overflowY: 'auto',
        }}
      >
        <div className=" delivery-faq-modal red-box">
          <CloseButton text="Close" extendClass="modal-btn-close" onClick={closeModalHandler} />
          <h1 className="h4">{modalTitle}</h1>

          {faqs &&
            faqs.map((question, index) => (
              <div className="mt-qa" key={index}>
                <p>
                  <span className="mt-question">
                    <strong>{question.Question}</strong>
                  </span>
                  <br />
                  <span className="mt-answer">{parse(question.Answer)}</span>
                </p>
              </div>
            ))}

          {parse(showMoreText)}
        </div>
      </MuiModal>
    </>
  );
};

DeliveryMethodsFaqModal.propTypes = {
  faqs: PropTypes.array,
  modalTitle: PropTypes.string,
  readMoreText: PropTypes.string,
  showMoreText: PropTypes.string,
};
